var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "is-content" },
    [
      _vm._v("\n  " + _vm._s(_vm.content) + "\n  "),
      _vm.subContent
        ? _c(
            "div",
            {
              staticClass: "mt8 color-gray-8",
              class: _vm.fullscreen ? "standard-size-16" : "standard-size-14",
            },
            [_vm._v(_vm._s(_vm.subContent))]
          )
        : _vm._e(),
      _vm.showInstruct
        ? [
            _c(
              "div",
              {
                staticClass: "yxtbiz-flex-center color-gray-9 mt12",
                class: _vm.fullscreen ? "standard-size-16" : "standard-size-14",
              },
              [
                _c("div", { staticClass: "flex-1 ellipsis" }, [
                  _vm._v(_vm._s(_vm.$t("pc_biz_ai_promot_tips"))),
                ]),
                _vm.list.length > 3
                  ? _c(
                      "div",
                      {
                        staticClass: "yxtbiz-flex-center hand",
                        on: { click: _vm.change },
                      },
                      [
                        _c("yxtf-svg", {
                          staticClass: "icon-copy",
                          attrs: {
                            width: "16px",
                            height: "16px",
                            "icon-class": "turn-right",
                          },
                        }),
                        _c("span", { staticClass: "ml6" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("pc_biz_ai_change_promot" /** 换一换 */)
                            )
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
            _c(
              "div",
              { staticClass: "yxtbiz-ai-robot__welcome-enter mt8" },
              _vm._l(_vm.randomList, function (item) {
                return _c(
                  "div",
                  {
                    key: item.id,
                    staticClass: "yxtbiz-ai-robot__welcome-enter-item",
                    class: _vm.fullscreen ? "is-item-horizontal" : "",
                    on: {
                      click: function ($event) {
                        return _vm.handle(item)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: _vm.fullscreen
                          ? "standard-size-16"
                          : "standard-size-14",
                      },
                      [_vm._v(_vm._s(item.appName))]
                    ),
                    item.guide
                      ? _c(
                          "div",
                          {
                            staticClass: "ellipsis-2 mt4 color-gray-8",
                            class: _vm.fullscreen
                              ? "standard-size-14"
                              : "standard-size-12",
                          },
                          [_vm._v(_vm._s(item.guide))]
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }